import React from "react";
 
const HttpBasicAuthentication = () => {
    return (
        <div className="container mt-4">
            <h1>HTTP Basic Authentication</h1>
            <div className="input-group mt-3">
                <textarea 
                    className="form-control w-50" 
                    id="exampleFormControlTextarea1" 
                    rows="10"></textarea>
            </div>
            <button type="submit" className="btn btn-secondary mt-2">Format</button>
        </div>
    );
};
 
export default HttpBasicAuthentication;